import { AdminRoutes } from './AdminRoutes';

export function AdminApp() {
  return <AdminRoutes />;
}
